import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { verify2FA, login } from './AuthService';
import { useAuth } from './AuthContext';
import { jwtDecode } from 'jwt-decode';

export default function TwoFactorPage() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [method, setMethod] = useState(localStorage.getItem('velaPreferredMethod') || 'email');
  const navigate = useNavigate();
  const { login: loginWithToken } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const tempToken = localStorage.getItem('velaTempToken');
    if (!tempToken) {
      setError('Session expired. Please log in again.');
      navigate('/login');
      return;
    }

    const response = await verify2FA(code, tempToken);

    if (response.token) {
      localStorage.setItem('velaToken', response.token);
      localStorage.removeItem('velaTempToken');
      loginWithToken(response.token);
      navigate('/midwife');
    } else {
      setError(response.message || 'Invalid code');
    }

  };

  const handleResendViaOtherMethod = () => {
    const otherMethod = method === 'sms' ? 'email' : 'sms';
  
    const confirmSwitch = window.confirm(
      `You chose to switch to ${otherMethod.toUpperCase()}.\n\nYou'll be redirected to log in again and we'll send the code via that method. Continue?`
    );
  
    if (confirmSwitch) {
      navigate('/login', { state: { forceMethod: otherMethod } });
    }
  };

  useEffect(() => {
    const tempToken = localStorage.getItem('velaTempToken');
    if (tempToken) {
      try {
        const decoded = jwtDecode(tempToken);
        if (decoded?.preferred2FAMethod) {
          setMethod(decoded.preferred2FAMethod.toLowerCase());
          return;
        }
      } catch (err) {
        console.warn('Failed to decode temp token', err);
      }
    }
  
    // fallback
    const stored = localStorage.getItem('velaPreferredMethod');
    setMethod((stored || 'email').toLowerCase());
  }, []);
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4 py-6">
      <div className="w-full max-w-sm bg-white p-6 rounded-xl shadow-md">
        <img src="/vela-logo.png" alt="Vela Logo" className="h-48 mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-center text-gray-700 mb-4">Two-Factor Authentication</h2>

        <p className="text-sm text-gray-600 mb-2 text-center">
          Enter the 6-digit code sent via <strong>{method === 'sms' ? 'SMS' : 'Email'}</strong>
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter code"
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <button
            type="submit"
            className="w-full py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg font-semibold transition"
          >
            Verify
          </button>
        </form>

        <button
          onClick={handleResendViaOtherMethod}
          className="w-full mt-4 text-sm text-emerald-600 hover:underline text-center"
        >
          Use {method === 'sms' ? 'Email' : 'SMS'} instead
        </button>
      </div>
    </div>
  );
}
